import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2TemplatesListResponse {
  list: Array<List>;
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
};

export interface List {
  id: number;
  template_id: string;
  template_name: string;
  agent_id: number;
  type: number;
  cover_url: string;
  cover_video: string;
  status: number;
  created_at: number;
  updated_at: number;
};


// 请求接口
export interface AgentUserGlobalTemplatesListRequest {
  agentId: string,
  type: number;
  page: number,
  pageSize: number,
  searchType: string,
  searchValue: string,
}

export class AssetsTemplatesData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Template id cannot be empty")
  @IsString("Template id must be a string")
  templateId: string;

  @Required("Template name cannot be empty")
  @IsString("Template name must be a string")
  templateName: string;

  @Required("Cover url cannot be empty")
  @IsString("Cover url must be a string")
  coverUrl?: string;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @Required("Cover video cannot be empty")
  @IsString("Cover video must be a string")
  coverVideo?: string;

  @Required("Enabled cannot be empty")
  @IsBoolean("Enabled must be a boolean")
  enabled: boolean;

  // @Required("Scene cannot be empty")
  @IsString("Scene must be a string")
  scene: string;
}

export class AssetsTemplatesListData {
  @IsArray("List must be an array")
  list: AssetsTemplatesData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  pageSize: number;

  // @Required("Total template count cannot be empty")
  @IsNumber("Total template count must be a number")
  totalTemplateCount: number;
}

const transformAndValidateAgent = (
  response: AgentV2TemplatesListResponse
): AssetsTemplatesListData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AssetsTemplatesListData);
  } catch (error) {
    console.error("Assets Templates data validation failed:", error.message);
    throw error;
  }
};

/** 企业用户模板列表 */
export const agentUserGlobalTemplatesList = async ({
  page,
  pageSize,
  agentId,
  type,
  searchType,
  searchValue,
}: AgentUserGlobalTemplatesListRequest): Promise<AssetsTemplatesListData> => {
  const response = await api.post<AgentV2TemplatesListResponse>('/agent/user-global-template/list', {
    agent_id: agentId,
    type,
    search_type: searchType,
    search_value: searchValue,
    page,
    page_size: pageSize,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
